// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"535":"d1437b4f7e4d1046","768":"3a72c0b076601c28"}[chunkId] + ".js";
};